
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiEsperienzeClassiDialog extends Serenity.EntityDialog<ProdottiEsperienzeClassiRow, any> {
        protected getFormKey() { return ProdottiEsperienzeClassiForm.formKey; }
        protected getIdProperty() { return ProdottiEsperienzeClassiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiEsperienzeClassiRow.localTextPrefix; }
        protected getService() { return ProdottiEsperienzeClassiService.baseUrl; }
        protected getDeletePermission() { return ProdottiEsperienzeClassiRow.deletePermission; }
        protected getInsertPermission() { return ProdottiEsperienzeClassiRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiEsperienzeClassiRow.updatePermission; }

        protected form = new ProdottiEsperienzeClassiForm(this.idPrefix);

    }
}